import { useQuery } from '@tanstack/react-query';
import { organizationsService } from '../api/organizations.service';
import { ORGANIZATIONS_KEYS } from './queryKeys';

export function useOrganization(id: string | null) {
  return useQuery({
    queryKey: ORGANIZATIONS_KEYS.detail(id ?? '', id ?? ''),
    queryFn: ({ signal }) => organizationsService.getById(id!, signal),
    enabled: !!id,
    staleTime: 120_000,
  });
}
